export default "__VITE_ASSET__DZCQWZWc__"